import React from 'react'
import Container from 'react-bootstrap/Container'
import SliderBanner from '../components/SliderBanner'
import { Puff, ThreeDots } from 'react-loader-spinner'
//
import AboutUS from '../components/AboutUS'
import WhyChooseUs from '../components/WhyChooseUs'
import OurProducts from '../components/OurProducts'
import LegalDocuments from '../components/LegalDocuments'
import BoardMembers from '../components/BoardMembers'
import Subscription from '../components/Subscription'
import AdBanner from '../components/AdBanner'
import SmallSlider from '../components/SmallSlider'
import HomePageService from '../../../services/HomePageService'
import LoadingContainer from '../../../components/common/LoadingContainer'
import BestSaleSlider from '../components/BestSaleSlider'

function Home() {
  const [loading, setLoading] = React.useState(true)
  const [homePageData, setHomePageData] = React.useState({})
  const {
    products,
    board_members,
    documents,
    reviews,
    top_sales,
    banners = [
      {
        image_path: null,
        title:
          "Elevate Your Life Organically Discover Nature's Best Kept Secrets!",
        description:
          'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a ',
      },
      {
        image_path: null,
        title:
          "Elevate Your Life Organically Discover Nature's Best Kept Secrets!",
        description:
          'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a ',
      },
    ],
  } = homePageData

  React.useEffect(() => {
    getHomePageData()
  }, [])
  const getHomePageData = async () => {
    setLoading(true)
    try {
      const response = await HomePageService.getHomePageData()
      setHomePageData(response)
      // console.log(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <LoadingContainer loading={loading}>
      <Container fluid className='p-0'>
        <SliderBanner data={banners} />
        <AboutUS />
        {top_sales?.length > 0 && <BestSaleSlider data={top_sales}/>}
        <WhyChooseUs />
        {products?.length > 0 && <OurProducts data={products} />}
        {documents?.length > 0 && <LegalDocuments data={documents} />}
        {board_members?.length > 0 && <BoardMembers data={board_members} />}
        {/* <AdBanner /> */}
        {reviews?.length > 0 && <SmallSlider data={reviews} />}
        <Subscription />
      </Container>
    </LoadingContainer>
  )
}

export default Home
